query TravelAuthorizationSearchFilterTotals(
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $searchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $isSearchAllData: Boolean
  $filterCreatedById: UUID
  $filterBusinessUnitId: UUID
  $filterCurrencyId: Int
  $filterDepartmentId: UUID
  $filterStatusTypeId: Int
  $filterIsCorporateOrigin: Boolean
  $filterIsProductionOrigin: Boolean
  $filterWorkgroupId: UUID
  $filterMultiStatusTypes: [Int]
) {
  travelAuthorizationSearchFilterTotals(
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    isSearchAllData: $isSearchAllData
    isSigningSearch: $isSigningSearch
    searchRequest: $searchRequest
    filterCreatedById: $filterCreatedById
    filterDepartmentId: $filterDepartmentId
    filterBusinessUnitId: $filterBusinessUnitId
    filterCurrencyId: $filterCurrencyId
    filterStatusTypeId: $filterStatusTypeId
    filterIsCorporateOrigin: $filterIsCorporateOrigin
    filterIsProductionOrigin: $filterIsProductionOrigin
    filterWorkgroupId: $filterWorkgroupId
    filterMultiStatusTypes: $filterMultiStatusTypes
  ) {
    totalCount1
    totalAmount1
    totalAmount4
  }
}